import React, { Component } from 'react'
import classNames from 'classnames'
import { CircleEmptyIcon as ValidIcon, ErrorIcon } from '../../Utils/Icons'

const ICON_STYLE = {
  position: 'absolute',
  right: 13,
  top: 23,
}

export default class Input extends Component {
  state = {
    isFocused: false,
  }

  render() {
    const {
      disabled,
      valid,
      error,
      className,
      wrapperClassName,
      style,
      inputRef,
      ColorIcon,
      RightIcon,
      rightText,
      ...props
    } = this.props
    const { isFocused } = this.state

    const _className = classNames(
      [
        'margin-vertical-small padding-horizontal-medium padding-vertical-normal',
        'font-size-small black',
        'border-small radius-normal',
        'flexbox-grow',
      ],
      {
        'border-shade-40': !isFocused && !valid && !error,
        'border-shade-30': isFocused && !valid && !error,
        'border-green': valid,
        'border-red': error,
        'cursor-forbidden': disabled,
      },
      disabled ? 'placeholder-shade-20' : 'placeholder-shade-30',
      disabled ? 'background-stripped-shade-100' : 'background-transparent',
      className
    )

    const _style = {
      ...style,
    }

    return (
      <div
        className={classNames('position-relative flexbox', wrapperClassName)}
      >
        <input
          className={_className}
          style={_style}
          disabled={disabled}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          ref={inputRef}
          {...props}
        />
        {rightText && (
          <div
            className="position-absolute flexbox flexbox-align-center shade-30 bold"
            style={{ right: 16, top: 0, bottom: 0 }}
          >
            {rightText}
          </div>
        )}
        {error && <ErrorIcon className="red" style={ICON_STYLE} />}
        {valid && <ValidIcon className="green" style={ICON_STYLE} />}
        {RightIcon && <RightIcon style={ICON_STYLE} value={props.value} />}
      </div>
    )
  }

  onFocus = e => {
    this.setState(state => ({
      isFocused: true,
    }))
    this.props.onFocus && this.props.onFocus(e)
  }

  onBlur = e => {
    this.setState(state => ({
      isFocused: false,
    }))
    this.props.onBlur && this.props.onBlur(e)
  }
}
